<template>
  <v-container>
    <ValidationObserver ref="form">
      <FormToolbar
        :title="edit ? 'Edit Activity' : 'New Activity'"
        :onSubmitClick="submitForm"
        :onCloseClick="onCloseClick"
      />
      <v-form class="mt-1" @keyup.enter.native="submitForm">
        <v-container>
          <v-row>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Activity Name"
                rules="required|max:50"
                v-slot="{ errors }"
              >
                <v-text-field
                  ref="firstInput"
                  v-model="entity.activityName"
                  :error-messages="errors"
                  label="Activity Name"
                  :counter="50"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Code"
                rules="required|max:25"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="entity.code"
                  label="Activity Code"
                  :error-messages="errors"
                  :counter="25"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Activity Type"
                rules="required|max:50"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="entity.activityType"
                  :error-messages="errors"
                  label="Activity Type"
                  :counter="50"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="8">
              <ValidationProvider rules="max:50" v-slot="{ errors }">
                <v-text-field
                  v-model="entity.activityInfo"
                  :error-messages="errors"
                  label="Activity Information"
                  :counter="50"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Location Type"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="entity.locationType"
                  :items="locationTypes"
                  item-text="value"
                  item-value="value"
                  :error-messages="errors"
                  label="Location Type"
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-checkbox
              v-model="entity.isBulkTransactionActivity"
              class="mx-2"
              label="Bulk Transaction Activity"
            ></v-checkbox>
            <v-checkbox
              v-model="entity.isSailingActivity"
              class="mx-2"
              label="Sailing Activity"
            ></v-checkbox>
            <v-checkbox
              v-model="entity.isShiftInPortActivity"
              class="mx-2"
              label="Shift In Port Activity"
            ></v-checkbox>
          </v-row>
          <v-row>
            <v-checkbox
              v-model="entity.isCargoHandlingActivity"
              class="mx-2"
              label="Cargo Handling Activity"
              :disabled="cargoHandlingDisabled">
            </v-checkbox>
            <v-checkbox
              v-model="entity.isCommentRequired"
              class="mx-2"
              label="Vessel Comment Required">
            </v-checkbox>
          </v-row>
          <v-row>
            <v-checkbox
              v-if="edit"
              v-model="entity.isActive"
              class="mx-2"
              label="Active"
            ></v-checkbox>
          </v-row>
        </v-container>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FormToolbar from '../ui/FormToolbar.vue';
import '../../validators';

export default {
  props: {
    edit: Boolean,
    entity: Object,
    onSubmitClick: Function,
    onCloseClick: Function,
    bus: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    FormToolbar,
  },
  computed: {
    ...mapState(['locationsStore']),
    locationTypes() {
      return this.locationsStore ? this.locationsStore.locationTypes : null;
    },
    cargoHandlingDisabled() {     
      return this.entity?.locationType ? this.entity.locationType.toLowerCase() === "none" : false;
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate()
        .then((isValid) => {
          if (isValid) this.onSubmitClick();
        });
    },
    resetForm() {
      this.$nextTick(() => this.$refs.firstInput.focus());
      this.$refs.form.reset();
    },
  },
  created() {
    this.$store.dispatch('locationsStore/loadLocationTypes');
  },
  mounted() {
    this.bus.$on('resetForm', this.resetForm);
    },
    watch: {
      cargoHandlingDisabled(isDisabled) {
        this.entity.isCargoHandlingActivity = isDisabled ? false : this.entity.isCargoHandlingActivity;
      }
    }
};
</script>

<style>
</style>
